import React from 'react';
import { MobxComponent } from "../../../mobx/components";
import { inject, observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { IconSettings, IconClose, IconDelete, IconWrapperRounded, IconKiosk, IconPickup, IconDelivery, IconDineIn, IconArrowForward } from "./icons";
import { ColorPicker, Switch } from "@lib/components";
import { HeaderTitleWrapper, MenuItem, QuickSettingsContainer, QuickSettingsHeaderWrapper, QuickSettingsBodyWrapper, QuickSettingsFooterWrapper, QuickSettingsButton, QuickSettingsItemsContainer, QuickSettingsItemsWrapper, QuickSettingsItemWrapper, ButtonV2, MenuColorHeaderWrapper, MenuColorHeaderTitleWrapper, MenuColorDescription, MenuColorBodyWrapper, MenuColorFormGroup, MenuColorLabel, MenuColorColorPickerWrapper, MenuColorColorPickerText, MenuColorPresetsList, MenuColorPresetsListItem, MenuColorPresetsListItemContent, MenuColorFooterWrapper, MenuToggleContainer, MenuToggleText, MenuServiceTypeContainer, MenuServiceTypeItem, MenuLineSeparator, MenuPublishPlatformContainer, MenuPublishPlatFormItem, MenuPublishPlatFormItemHeader, MenuPublishPlatFormItemHeaderLabel, MenuStatusAlert, MenuStatusAlertText, MenuStatusLabelAvailable, MenuStatusServiceList, MenuStatusServiceListItem, MenuStatusServiceListRow, MenuStatusShowSettingsContainer, MenuStatusShowSettingsText, MenuActionContainer, MenuActionItem } from "./layout.c";
import { CoreUtils } from '@lib/common';
import { MoreActionSideBar } from './more-action-menu';


interface Props extends WithTranslation {
    show?: boolean;
    onHide?: () => void;
    onSave: (color: string) => void;
    onShowSettings?: () => void;
    title?: string;
    value?: string;
    children?: React.ReactNode;
    itemCount?: number;
    hideOnMobile?: boolean;
}
interface State {
    color: string;
}

@inject("store") @observer
class MenuMoreActionClass extends MobxComponent<Props, State> {
    constructor(props: Props) {
		super(props);
		this.state = {
            color: props.value || '#000000'
        };
	}

    render() {
        const { store, t } = this.injected;
        const auth = store.auth;
        const { show, onHide, onSave, title, onShowSettings, children, itemCount, hideOnMobile } = this.props;
        const { color } = this.state;
        const loginEmail = auth?.item?.email;
        const isSupportLogin: any = (loginEmail?.toLowerCase() == "support@cloudwaitress.com");
        const menus_detail = auth?.item?.restrictions?.restaurant?.menus_detail;
        const exportPermisson = menus_detail ? menus_detail?.export : true;
        const importPermisson = menus_detail ? menus_detail?.import : true;
        let canExport = isSupportLogin || exportPermisson;
        let canImport = isSupportLogin || importPermisson;

        return (
        <QuickSettingsContainer className={show ? 'active': ''} hideOnMobile={hideOnMobile}>
            <MenuColorHeaderWrapper>
                <MenuColorHeaderTitleWrapper>
                    <span className="notranslate">{title || 'Acme Pizza'}</span>
                </MenuColorHeaderTitleWrapper>
                <MenuItem onClick={onHide}><IconClose /></MenuItem>
            </MenuColorHeaderWrapper>
            <MenuColorBodyWrapper style={{minHeight: '50vh', overflowY:'scroll'}}>
                <MenuColorLabel>
                    {itemCount ? (
                        `${itemCount} item(s) selected`
                    ) : (
                        <span className="notranslate">{title}</span>
                    )}
                </MenuColorLabel>

                {children ?  children : (
                <MenuActionContainer>
                    <MenuActionItem
                        onClick={() =>  {
                            store.setActiveMobileMenu('templates', ['menus'])
                            onHide?.()
                        }}>
                        Templates</MenuActionItem>
                    {store.isMainReseller && <MenuActionItem
                        onClick={() =>  {
                            store.setActiveMobileMenu('upload-services', ['menus'])
                            onHide?.()
                        }}>
                        Upload Services</MenuActionItem> }

                    {canImport &&<MenuActionItem
                        onClick={() => {
                            store.setActiveMobileModal('desktop-csv-import')
                        }}>Import Menu</MenuActionItem> }
                    {canExport && <MenuActionItem
                    onClick={() => {
                        store.setActiveMobileModal('desktop-csv-export')
                    }}>Export Menu</MenuActionItem>}
                    <MenuActionItem
                        onClick={() => {
                            store.setActiveMobileModal('desktop-filter-menu')
                            //onHide?.()
                        }}
                        >Filter Menu</MenuActionItem>
                    <MenuActionItem
                        onClick={() => {
                            store.setActiveMobileModal('desktop-printer-settings')
                            //onHide?.()
                        }}
                    >Printer Settings</MenuActionItem>
                    <MenuActionItem
                        onClick={() => {
                            store.setActiveMobileModal('desktop-version-history')
                        }}
                    >Version History</MenuActionItem>
                </MenuActionContainer> ) }
            </MenuColorBodyWrapper>
        </QuickSettingsContainer>
        )
    }
}
export const MenuMoreAction = withTranslation()(MenuMoreActionClass);
